/**
 * @file 历史提问区：@ / Skill 引用以 icon + 正文展示（无 pill tag）
 */
import React, { useMemo } from 'react';
import KnowledgeMentionIcon from '@/pages/aigc/assets/svg/skill-mention.svg';
import SkillSlashIcon from '@/pages/aigc/assets/svg/skill-slash-icon.svg';
import { parseSerializedMentions } from '../../../components/QAInput/mentionEditor/mentionTokenDom';
import { patchCollapsedKbCountMentionMarkers } from '../../../components/QAInput/utils/inlineMentionRanges';
import type { TMentionEditorKind } from '../../../components/QAInput/mentionEditor/types';
import './InlineMentionText.scss';

export interface IInlineMentionTextProps {
  /** 提问正文（优先 display_query） */
  text: string;
  /** 知识库折叠单位，如 篇 / docs */
  kbDocUnit?: string;
  className?: string;
  style?: React.CSSProperties;
}

const MENTION_TRIGGER_ICON: Record<TMentionEditorKind, string> = {
  knowledge: KnowledgeMentionIcon,
  skill: SkillSlashIcon,
};

/** 历史提问区：mention 与正文同一行流式排版，触发符用 icon */
const InlineMentionText: React.FC<IInlineMentionTextProps> = ({
  text,
  kbDocUnit = '篇',
  className,
  style,
}) => {
  const nodes = useMemo(() => {
    if (!text) return null;

    const segments = parseSerializedMentions(
      patchCollapsedKbCountMentionMarkers(text, kbDocUnit),
    );
    if (!segments.length) return text;

    return segments.map((segment, index) => {
      if (segment.type === 'text') {
        return (
          <React.Fragment key={`t-${index}`}>{segment.text}</React.Fragment>
        );
      }
      return (
        <span
          key={`m-${segment.mentionKey}-${index}`}
          className={`dba-inline-mention-text__mention dba-inline-mention-text__mention--${segment.kind}`}
        >
          <span className="dba-inline-mention-text__trigger">
            <img
              src={MENTION_TRIGGER_ICON[segment.kind]}
              alt=""
              className="dba-inline-mention-text__trigger-icon"
              draggable={false}
            />
          </span>
          {segment.body}
        </span>
      );
    });
  }, [text, kbDocUnit]);

  return (
    <span
      className={['dba-inline-mention-text', className].filter(Boolean).join(' ')}
      style={style}
    >
      {nodes}
    </span>
  );
};

export default InlineMentionText;
